export enum RECEIVED_PRODUCT_STATUS {
  RECIBIDO_OK = 0,
  A_REVISION_REPARACION = 1,
  NO_CONFORME = 2,
}

export const ReceivedProductStatusStrings: Record<RECEIVED_PRODUCT_STATUS, string> = {
  [RECEIVED_PRODUCT_STATUS.RECIBIDO_OK]: 'Recibido Ok',
  [RECEIVED_PRODUCT_STATUS.A_REVISION_REPARACION]: 'A revisión/reparación',
  [RECEIVED_PRODUCT_STATUS.NO_CONFORME]: 'No conforme',
};
